import "./ProfilePicture.scss"
import React, { useState } from 'react'
import FileUploader from 'devextreme-react/file-uploader'

interface ProfilePictureProps {
    profilePicture?: string
    editable?: boolean
}

export const ProfilePicture: React.FC<ProfilePictureProps> = (props) => {
    const [profilePicture, setProfilePicture] = useState<string>('')

    const handleFileUpload = (e: any) => {
        const file = e.value[0];
        const reader = new FileReader()

        reader.onload = () => {
            if (reader.result) {
                setProfilePicture(reader.result.toString().split(',')[1])
            }
        };

        if (file) {
            reader.readAsDataURL(file)
        }
    };

    return (
        <>
            <div className={`form-photo ${props.editable ? 'editable' : ''}`}>
                <i className='edit-icon dx-icon-photooutline' />
                <img className='profile-image' src={props.profilePicture} alt='' />
            </div>
            { props.editable &&
                <FileUploader
                    dialogTrigger='.form-photo'
                    accept='image/*'
                    visible={false}
                />
            }
        </>
    );
};
